import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ae107ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-training-view" }
const _hoisted_2 = { class: "audio-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "division" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "division margintop" }, null, -1))

import {computed, ref, onMounted, watch} from 'vue'
  import {useStore} from 'vuex'
  import {useRoute, useRouter} from 'vue-router'

  import {t} from '@/lib/i18n.js'

  import ContentSection from '@/components/ContentSection.vue'
  import AudioSelectionForm from '@/components/forms/AudioSelectionForm.vue'
  import IconsExample from '@/components/IconsExample.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AudioSelectionChoiceView',
  setup(__props) {

  const router = useRouter()
  const store = useStore()
  const errors = ref({})

  const titleText = computed(() => t(store, 'chart.title'))
  const beginText = computed(() => t(store, 'chart.begin'))
  const audioLocations = store.state.audioLocations
  const translated = []
  audioLocations.forEach((item) => {
    translated.push({key: item.key, value: computed(() => t(store, item.key))})
  })

  const audioActive = ref(false)

  onMounted(() => {
    setTimeout(() => {
      audioActive.value = false
    }, 1)

    return
  })

  const onSubmit = () => {
    //router.push({name: 'active.science-intro-intro'})
    router.push({name: 'active.listen'})
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ContentSection, { class: "content audio-warning" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(titleText)), 1)
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(IconsExample),
    _hoisted_4,
    _createVNode(ContentSection, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(beginText)), 1)
      ]),
      _: 1
    }),
    _createVNode(AudioSelectionForm, {
      options: translated,
      errors: errors.value,
      "model-value": {},
      onSubmit: onSubmit
    }, null, 8, ["errors"])
  ]))
}
}

})